var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.98931e-05 33.5506C0.273031 31.4857 0.569201 29.4246 1.08846 27.3981C4.51556 13.974 15.9662 3.1378 29.6169 0.669091C41.229 -1.42662 51.6219 1.39586 60.5647 9.11731C67.3535 14.9815 71.4499 22.4453 72.623 31.328C74.2346 43.5408 70.696 54.1617 61.8955 62.8444C56.176 68.4856 49.1987 71.731 41.2175 72.7731C40.679 72.8423 40.1405 72.9269 39.602 73H33.4748C33.3594 72.9692 33.2478 72.9231 33.1325 72.9116C27.9976 72.4693 23.1627 71.0235 18.6932 68.4702C9.86969 63.4289 4.05785 55.9882 1.22308 46.2287C0.599972 44.083 0.29611 41.8758 -0.00390625 39.6724V33.5468L-5.98931e-05 33.5506ZM2.90394 36.6384C3.07318 55.0884 17.747 70.0775 36.548 70.066C55.0798 70.0545 70.0152 55.1768 69.9998 36.5577C69.9844 17.7309 54.9144 2.9763 36.4288 3.02244C17.7586 3.06474 3.01164 17.9654 2.90394 36.6384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7454 36.6077C56.7377 38.911 54.8761 40.7222 52.5298 40.7068C50.1874 40.6914 48.3757 38.8687 48.3873 36.5423C48.395 34.2428 50.2643 32.3778 52.5644 32.3778C54.8799 32.3778 56.7569 34.2736 56.7492 36.6077H56.7454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5213 32.3778C38.7791 32.3778 40.633 34.2774 40.6369 36.5923C40.6369 38.8611 38.7945 40.7068 36.5213 40.7068C34.2058 40.7068 32.3018 38.8457 32.3057 36.5923C32.3057 34.3005 34.2288 32.3778 36.5213 32.3778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4778 36.5385C16.4894 34.2197 18.3472 32.3509 20.6204 32.3778C22.8589 32.4009 24.8052 34.3543 24.7975 36.5769C24.7898 38.8303 22.882 40.703 20.5857 40.7068C18.2625 40.7145 16.4663 38.8918 16.4778 36.5423V36.5385Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.c15ba9a41f0b24dc7808543b842f1060.svg";
export { ForwardRef as ReactComponent };